// extracted by mini-css-extract-plugin
module.exports = {"trailHeader":"TrailPageWrapper_trailHeader__eVLL9"};